// extracted by mini-css-extract-plugin
export default {"formContainer":"style_formContainer__TWlQl","email":"style_email__KWWEA","errorMsg":"style_errorMsg__7WxKn","prevEmail":"style_prevEmail__HJnAM"};